/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Spaces_Open_Floating_Explorer_ForInputs */



/**
* | output |
* | --- |
* | "Open floating explorer for {name}" |
*
* @param {Spaces_Open_Floating_Explorer_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_open_floating_explorer_for = /** @type {((inputs: Spaces_Open_Floating_Explorer_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Open_Floating_Explorer_ForInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Schwebenden Explorer für ${i?.name} öffnen`)
	return /** @type {LocalizedString} */ (`Open floating explorer for ${i?.name}`)
});